import { SET_ACTIVECONTENTTABINDEX, SET_ACTIVEOBJ, SET_LOGPERMISSION_FLAG, SET_POPUPFLAG, SET_ROUTE, SET_SETTING_FLAG, SET_CURRENT_USER } from "./actionTypes";
import initialState from './initialState'

const routeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ROUTE:
            return {
                ...state,
                route: action.payload
            };
        case SET_SETTING_FLAG:
            return {
                ...state,
                settingFlag: action.payload
            }

        case SET_LOGPERMISSION_FLAG:
            return {
                ...state,
                loginPermissionFlag: action.payload
            }
        case SET_ACTIVECONTENTTABINDEX:
            return {
                ...state,
                activeContentTabIndex: action.payload
            }
        case SET_ACTIVEOBJ:
            return {
                ...state,
                activeObj: action.payload
            }
        case SET_POPUPFLAG:
            return {
                ...state,
                popupFlag: action.payload
            }
        case SET_CURRENT_USER:
            return {
                ...state,
                currentUser: action.payload
            }
        default:
            return state;
    }
};

export default routeReducer;
